import { useSincronizarAvances } from '@/hooks/useAvance';
import { Outlet } from 'react-router-dom';
import { BottomNavCampo } from './BottomNavCampo';
import { HeaderAdelante } from './HeaderAdelante';

/**
 * Layout del área Campo — responsive.
 *
 * Mobile-first para el personal de obra con celular, pero aprovecha el ancho
 * en tablet/PC (el supervisor suele estar en una pantalla grande):
 *   - Móvil: contenedor angosto (max-w-md).
 *   - Tablet/desktop: ensancha (md:max-w-3xl, lg:max-w-5xl, xl:max-w-7xl).
 *   - Las vistas Kanban/Matriz son full-bleed (w-screen) e ignoran este ancho.
 *   - pb-24 deja espacio para la BottomNav fija.
 */
export function LayoutCampo() {
  // Drena la cola de avances offline al recuperar conexión.
  useSincronizarAvances();

  return (
    <div className="min-h-screen overflow-x-clip bg-zinc-50 text-foreground">
      <HeaderAdelante variant="campo" />
      <main className="mx-auto w-full max-w-md px-4 pb-24 pt-4 md:max-w-3xl lg:max-w-5xl xl:max-w-7xl">
        <Outlet />
      </main>
      <BottomNavCampo />
    </div>
  );
}
